'use client';

import { host } from '@/config';
import { CAMPAIGN_TAG } from '@/domain/campaign';
import { CampaignState } from '@/types/campaign';
import { MESSAGE_BOX_STATE, MessageBox } from '../MessageBox/MessageBox';
import { useDiscountBanner } from './useDiscountBanner';

export const DISCOUNT_BANNER_TEST_ID = 'discount-banner';

type DiscountBannerProps = {
  campaignInfo: CampaignState | null;
};

export function DiscountBanner({ campaignInfo }: DiscountBannerProps) {
  const { showBanner, bannerType, handleClose } = useDiscountBanner({ campaignInfo });

  if (!showBanner || !bannerType) return null;

  return (
    <div className="tc-container mt-5 md:mb-5" data-component={DISCOUNT_BANNER_TEST_ID}>
      <MessageBox
        onClose={handleClose}
        state={bannerType === 'success' ? MESSAGE_BOX_STATE.SUCCESS : MESSAGE_BOX_STATE.ERROR}
      >
        {bannerType === 'success' ? (
          <>
            Your discount will be applied at the checkout. Enter your reg to get a quote!
            <a
              href={`${host}/help-centre/promotions?${CAMPAIGN_TAG}=${campaignInfo?.campaignRef}`}
              className="ml-2 text-white underline"
            >
              T&Cs apply
            </a>
            .
          </>
        ) : (
          <>Sorry! This discount has expired.</>
        )}
      </MessageBox>
    </div>
  );
}
